import axios from "axios";
import {getAccessToken, processRefreshToken} from "../services/authService";

const API_URL = process.env.REACT_APP_API_URL;

// базовый клиент без токена — для login/logout/refresh
export const api = axios.create({
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json"
    },
    withCredentials: true
});

// авторизованный клиент
export const authApi = axios.create({
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json"
    },
    withCredentials: true
});

// вставляем токен в каждый запрос
authApi.interceptors.request.use(async (config) => {
    const token = await getAccessToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});


let isRefreshing = false;
let subscribers = [];

function subscribeTokenRefresh(cb) {
    subscribers.push(cb);
}

// newToken === null означает, что refresh не удался: будим очередь,
// чтобы ожидающие запросы не висели вечно, а корректно отклонились
function onAccessTokenFetched(newToken) {
    subscribers.forEach(cb => cb(newToken));
    subscribers = [];
}

authApi.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // если токен просрочен
        if (error.response?.status === 403 && !originalRequest._retry) {
            originalRequest._retry = true;
            // уже обновляется — ждём
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    subscribeTokenRefresh(token => {
                        if (!token) {
                            reject(error);
                            return;
                        }
                        originalRequest.headers.Authorization = `Bearer ${token}`;
                        resolve(authApi(originalRequest));
                    });
                });
            }

            // начинаем refresh токена
            isRefreshing = true;

            try {
                const newToken = await processRefreshToken();
                isRefreshing = false;
                onAccessTokenFetched(newToken);

                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                return authApi(originalRequest);
            } catch (e) {
                isRefreshing = false;
                onAccessTokenFetched(null); // разбудить и отклонить очередь
                return Promise.reject(e);
            }
        }

        return Promise.reject(error);
    }
);


export async function loginUser(username, password) {
    return await api.post("/v1/auth/login", { login: username, password: password });
}

export async function logoutUser() {
    return await api.post("/v1/auth/logout");
}

export async function refreshToken() {
    return await api.post("/v1/auth/token");
}

export async function getProfile() {
    return await authApi.get("/v1/users/profile");
}